import React, { useMemo } from "react";

// @material-ui/core components
import { GridLegacy } from "@mui/material";

// core components
import CardBody from "../../../components/Card/CardBody";
import Card from "../../../components/Card/Card";

import allergenen from "../../../../variables/allergenen";
import TranslationWrapper from "../../../components/TranslationWrapper/TranslationWrapper.tsx";
import { useFormContext } from "react-hook-form";
import FormAsyncTC from "../../../components/Forms/FormAsyncTC";
import { CustomizableTexts } from "../../../components/CustomizableTexts/CustomizableTexts";

function Allergens() {
  const { menukaartVestigingId, vestigingId } = useFormContext();

  const allergenenCheckboxen = useMemo(
    () =>
      Object.keys(allergenen).map((item, key) => {
        return (
          <GridLegacy item key={item} md={4} style={{ textAlign: "center" }} xl={2} xs={6}>
            <img src={"/img/allergenen/" + allergenen[item].icon_red_50} />
            <FormAsyncTC
              async={{
                url:
                  "core/producten/search?fields=id as value, naam as label&per_page=50&sort_field=naam&vestiging_id=" +
                  menukaartVestigingId,
                searchField: "naam",
              }}
              key={"custom_data.allergen_product_map" + menukaartVestigingId}
              name={"custom_data.allergen_product_map." + item}
            />
            <h6 style={{ textAlign: "center" }}>
              <TranslationWrapper tDefault={allergenen[item].label} tKey={"allergenen" + "." + "icon.label." + item} />
            </h6>
          </GridLegacy>
        );
      }),
    []
  );

  return (
    <Card>
      <CardBody>
        <GridLegacy container spacing={1}>
          <GridLegacy item xs={12}>
            <h3>
              <TranslationWrapper tDefault={"Allergens settings"} tKey={"custom_data.allergen_product_map.title"} />
            </h3>
          </GridLegacy>

          <GridLegacy item xs={12}>
            <CustomizableTexts
              translatableTexts={[
                "allergens_subtext",
                "tag_preferences_subtext",
                "allergens page - title",
                "allergens page - hide toggle button text",
              ]}
              vestigingId={vestigingId}
            />
          </GridLegacy>

          <GridLegacy item xs={12}>
            <h4>
              <TranslationWrapper
                tDefault={"Select a product which will automatically be added to your order"}
                tKey={"custom_data.allergen_product_map.selectProduct"}
              />
            </h4>
          </GridLegacy>

          {allergenenCheckboxen}
        </GridLegacy>
      </CardBody>
    </Card>
  );
}

export default Allergens;
